export default __webpack_public_path__ + "static/media/business-functions-on.071e2e8b.png";